import React from "react";
import { motion } from "framer-motion";
import { Scale, Gavel, ScrollText, Briefcase, Unlock, Home, Building2, Users, ShoppingBag, Handshake } from "lucide-react";

const areas = [
  { icon: Gavel, title: "Criminal Law", desc: "Trial and appellate representation across offences." },
  { icon: Scale, title: "Civil Litigation", desc: "Suits, appeals and revisions before civil courts." },
  { icon: ScrollText, title: "Constitutional Writs", desc: "Petitions under Articles 226 and 227." },
  { icon: Briefcase, title: "Service Matters", desc: "Departmental enquiries and service tribunal appeals." },
  { icon: Unlock, title: "Bail & Anticipatory Bail", desc: "Applications under Sections 437, 438 & 439 CrPC." },
  { icon: Home, title: "Property Disputes", desc: "Title, partition, injunction and possession suits." },
  { icon: Building2, title: "Commercial Litigation", desc: "Contracts, recovery and Commercial Courts Act." },
  { icon: Users, title: "Family Law", desc: "Maintenance, custody, divorce and succession." },
  { icon: ShoppingBag, title: "Consumer Matters", desc: "Consumer disputes and redressal commissions." },
  { icon: Handshake, title: "Arbitration", desc: "Sec. 9 & 34 petitions and arbitral proceedings." },
];

export default function PracticeAreas() {
  return (
    <section id="practice" className="py-24 md:py-40 bg-[#0B0B0B]" data-testid="practice-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-24">
        <div className="mb-16 md:mb-20 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-white/95">Practice<br/><span className="italic text-[#C8A45D]/90">Areas.</span></h2>
          </div>
          <div className="text-white/50 max-w-md font-body text-sm md:text-base">
            Ten focused areas of litigation and advisory, each handled with the same care and preparation that define the chamber&apos;s practice.
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-px bg-white/5">
          {areas.map((a, i) => {
            const Icon = a.icon;
            return (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.7, delay: (i % 5) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="practice-card bg-[#0B0B0B] p-8 md:p-10 min-h-[260px] flex flex-col justify-between cursor-default"
                data-testid={`practice-${a.title.toLowerCase().replace(/[^a-z]+/g,'-')}`}
              >
                <Icon className="text-[#C8A45D]" strokeWidth={1.1} size={28}/>
                <div>
                  <div className="font-cinzel text-[9px] tracking-[0.3em] text-white/30 mb-2">{String(i+1).padStart(2,"0")}</div>
                  <h3 className="font-serif-display text-2xl text-white mb-2 leading-tight">{a.title}</h3>
                  <p className="text-white/45 text-xs font-body leading-relaxed">{a.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
